export default "__VITE_ASSET__BjaaSoyK__"